import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  title?: string;
  description?: string;
  linkText?: string;
  linkUrl?: string;
};

const ComingSoon: React.FC<Props> = ({
  title = 'Coming Soon',
  description = 'This feature is currently under development and will be available soon.',
  linkText = 'Return Home',
  linkUrl = '/',
}) => {
  return (
    <div className='d-flex flex-column flex-center text-center h-100 mt-7'>
      <div className='card card-flush w-lg-650px py-5'>
        <div className='card-body py-15 py-lg-20'>
          <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>
            🚀 {title}
          </h1>

          <div className='fw-semibold fs-6 text-gray-500 mb-7'>
            {description}
          </div>

          <div className='mb-7'>
            <i className='ki-filled ki-rocket fs-5tx text-primary'></i>
          </div>

          <div className='text-gray-600 mb-10'>
            We're working hard to bring you this functionality.
            Please check back later.
          </div>

          <div>
            <Link className='btn btn-sm btn-primary' to={linkUrl} data-discover="true">
              {linkText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;